
// const BASE_URL = "https://localhost:8443"
const BASE_URL = "https://api.gaurangavedic.org.in:8443"
export const LOGIN_URL = BASE_URL + "/oauth2/authorization/google";
export const CHECK_AUTHENTICATION_URL = BASE_URL + "/auth";
export const LOGOUT = BASE_URL + "/logout";
export const PARENT_DOMAIN = "gaurangavedic.org.in";